<template>
  <div class="report-viewer-page">
    <Loader v-if="isLoading" />
    <p v-if="error" class="report-viewer-error">{{ error }}</p>
    <div ref="container" class="report-viewer-embed"></div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount, nextTick } from "vue";
import { useRoute } from "vue-router";
import Loader from "@/components/Loader.vue";
import { usePowerBiEmbed } from "@/composables/reports/usePowerBiEmbed";
import { $api } from "@/services/api1";

const route = useRoute();
const container = ref<HTMLDivElement | null>(null);
const { isLoading, error, embed, reset } = usePowerBiEmbed();

onMounted(async () => {
  await nextTick();

  const id = Number(route.params.id);
  if (!container.value || Number.isNaN(id)) {
    error.value = "Report not found.";
    return;
  }

  isLoading.value = true;
  const token = await $api.reports.getEmbedToken(id);

  if (!token || !token.token) {
    error.value =
      "There was an issue opening the report. Please try again later or contact Member Support.";
    isLoading.value = false;
    return;
  }

  embed(container.value, token);
});

onBeforeUnmount(() => {
  reset();
});
</script>

<style scoped>
.report-viewer-page {
  position: fixed;
  inset: 0;
  display: flex;
  flex-direction: column;
  background: white;
}

.report-viewer-embed {
  flex: 1;
  width: 100%;
  height: 100%;
  min-height: 0;
}

.report-viewer-error {
  padding: 16px 20px;
  color: #b00020;
  font-size: 14px;
}
</style>
